export const anaesthetistOptions = [
  "Dr. Anil Mehta",
  "Dr. Priya Iyer",
  "Dr. Rakesh Nair",
  "Dr. Neha Sharma",
  "Dr. Vivek Rao",
  "Dr. Aarti Desai"
];

export const surgeonOptions = [
  "Dr. John Smith",
  "Dr. Emily Johnson",
  "Dr. Richard Garcia",
  "Dr. Nancy Young",
  "Dr. Sandra Green"
];

export const oralNasalOptions = ["Oral", "Nasal"];
export const cuffedOptions = ["Cuffed", "Uncuffed"];
export const ivAccessOptions = ["Yes", "No"];
export const preOxygenationOptions = ["Yes", "No"];
export const rapidSequenceOptions = ["Yes", "No"];
export const throatPackOptions = ["Yes", "No"];

export const monitoringKeys = [
  { key: "spo2", label: "SpO₂" },
  { key: "ecg", label: "ECG" },
  { key: "nibp", label: "NIBP" },
  { key: "etco2", label: "ETCO₂" },
  { key: "fio2", label: "FiO₂" },
  { key: "temp", label: "Temperature" },
  { key: "cvp", label: "CVP" },
  { key: "arterialLine", label: "Arterial Line" },
  { key: "uop", label: "Urine Output" },
];

export const gasConcentrationFields = [
  { key: "n2o", label: "N₂O/O₂/Air Mix", placeholder: "e.g., 50/50/0%" },
  { key: "oxygenF1Fe", label: "Oxygen FiO₂/FeO₂", placeholder: "e.g., 0.5/0.45" },
  { key: "vapourF1Fe", label: "Volatile Agent", placeholder: "e.g., Sevo 1.5%" },
];

export const additionalMonitoringFields = [
  { key: "ecgPosition", label: "ECG Lead Position", placeholder: "Lead II, V5" },
  { key: "temperatureReading", label: "Core Temperature", placeholder: "e.g., 36.8°C" },
];

export const fluidManagementFields = [
  { key: "ivFluid", label: "IV Fluids", placeholder: "Type & Rate (ml/hr)" },
  { key: "bloodLoss", label: "Estimated Blood Loss", placeholder: "ml" },
  { key: "urineOutput", label: "Urine Output", placeholder: "ml/hr" },
  { key: "tourniquet", label: "Tourniquet Time", placeholder: "Duration (min)" },
];

export const proceduresList = [
  { key: "drugReversal", label: "Drug Reversal" },
  { key: "postOperative", label: "Post Operative Care" },
  { key: "postOpWard", label: "Post Op Ward Transfer" },
  { key: "delayedRecovery", label: "Delayed Recovery" },
  { key: "drugReaction", label: "Drug Reaction" },
  { key: "aspiration", label: "Aspiration Event" },
  { key: "cardiacArrest", label: "Cardiac Event" },
  { key: "others", label: "Other Complications" },
];
